import { _SvProcesaFacturaCatalogo } from "../../../../data/modulo/FacturaCatalogo"
import { _SvFacturaObtenerCatalogoSATMetodoPago, _SvFacturaObtenerTiposDocumentos } from "../../../../data/modulo/FacturaCatalogoSAT"
import { _SvFacturaObtenerSeries } from "../../../../data/modulo/FacturaSerie"
import _L from "../../../../util/Labels"
import { FormGenerator } from "../../../controlD3/Formulario"

export namespace UIUtilViewAlumnoEdoCtaFacturacionViewCFDIInfoGeneral {
    export interface ICFDIInfoGeneral {
        // Cliente: string
        /** @example "43000" (CP) */
        LugarExpedicion: string
        // LugarExpedicionId: number
        /** @example "PUE" */
        MetodoPago: string
        // Moneda: string
        // NumeroDecimales: string
        Serie: number
        TipoCfdi: string
    }

    export function _CrearInformacionGeneralForm(container: TSelectionHTML, idEscuela: number) {
        const initData = <ICFDIInfoGeneral>{
            TipoCfdi: "factura",
        }

        const formInfGral = new FormGenerator<ICFDIInfoGeneral>()

        formInfGral._Crear({
            schema: [
                {
                    model: "TipoCfdi", type: "selectMaterial", labelText: _L("panelfinanzasedocuenta_factura.tipo_cfdi"),
                    selectMaterialAttr: {
                        required: true,
                        valueMember: "key",
                        displayMember: "name",
                        disabled: true,
                        removeBorder: true,
                        Data: _SvFacturaObtenerTiposDocumentos(),
                    }
                },
                { model: "LugarExpedicion", type: "input", labelText: _L("panelfinanzasedocuenta_factura.lugar_expedicion"), inputAttr: { required: true, minlength: 5, maxlength: 5 } },
                {
                    model: "Serie", type: "selectMaterial", labelText: _L("panelfinanzasedocuenta_factura.serie"),
                    selectMaterialAttr: {
                        required: true,
                        valueMember: "SerieID",
                        displayMember: "SerieDescription",
                        Data: _SvProcesaFacturaCatalogo(_SvFacturaObtenerSeries(idEscuela))
                            .then(lista => {
                                formInfGral._SetModelValue("Serie", lista[0]?.SerieID)
                                return lista.map(d => {
                                    d.SerieDescription = `${d.SerieName} - ${d.SerieDescription}`
                                    return d
                                })
                            }),
                    },
                },
                {
                    model: "MetodoPago", type: "selectMaterial", labelText: _L("panelfinanzasedocuenta_factura.metodo_pago"),
                    selectMaterialAttr: {
                        required: true,
                        valueMember: "key",
                        displayMember: "name",
                        disabled: true,
                        removeBorder: true,
                        Data: _SvProcesaFacturaCatalogo(_SvFacturaObtenerCatalogoSATMetodoPago(idEscuela))
                            .then(lista => {
                                formInfGral._SetModelValue("MetodoPago", lista[0].key)
                                if (lista.length) {
                                    lista = [lista[0]]
                                }
                                return lista
                            }),
                    },
                },
            ]
        })

        container.append(() => formInfGral._Form.node())
            .style("max-width", "550px")

        formInfGral._AsignaData(initData)

        return formInfGral;
    }
}